export { default } from '@shikijs/langs/xml'
